import Typography from '@alltrails/core/components/Typography';
import Search from '@alltrails/denali/icons/Search';
import styles from './ReviewSearchSuggestion.module.scss';

type ReviewSearchSuggestionProps = {
  suggestionText: string;
};

const ReviewSearchSuggestion = ({ suggestionText }: ReviewSearchSuggestionProps) => (
  <div className={styles.container}>
    <div className={styles.icon}>
      <Search />
    </div>
    <Typography component="div" variant="text200">
      {suggestionText}
    </Typography>
  </div>
);

export default ReviewSearchSuggestion;
